<template>
  <div>
    <products-reviews-table
      class="mb-4"
      :table-data="reviews"
      :fields="fields"
      :loading="loading"
      @updateReviews="fetchReviews"
    />
  </div>
</template>

<script>
import api from "@/api/axios";
import ProductsReviewsTable from "../../components/products-reviews/table.vue";
export default {
  name: "ProductsReviews",
  components: {
    ProductsReviewsTable,
  },
  data() {
    return {
      reviews: [],
      loading: false,
    };
  },
  computed: {
    fields() {
      return [
        {
          name: "__slot:id",
          title: "№",
        },
        {
          name: "__slot:message",
          title: "Комментарий",
        },
        {
          name: "__slot:likes",
          title: "👍",
        },
        {
          name: "__slot:dislikes",
          title: "👎",
        },
        {
          name: "__slot:status",
          title: "Статус",
        },
        {
          name: "__slot:actions",
          title: "",
        },
      ];
    },
  },
  created() {
    this.fetchReviews();
  },
  methods: {
    async fetchReviews() {
      try {
        this.loading = true;
        await api
          .get("/admin/product-comments", {
            params: {
              all: 1,
            },
          })
          .then((res) => {
            this.reviews = res.data.data;
            this.loading = false;
          });
      } catch (error) {
        this.loading = false;
        return error;
      }
    },
  },
};
</script>
